import SVG from "../core/SVG";

const IncidentLocation = () => {
    return (
        <div className="incident-location d-flex flex-j-start flex-a-center gap-5 pb-10 pt-10">
            <SVG svg="map-pointer" size={24} className="red-svg" />
            <span className="momeentoo-p white-text">
                some location at some location
            </span>
        </div>
    );
};

export default IncidentLocation;
